import React, { useState } from "react";
import GovtOfficial from "../../Images/Govt. Official.png";
import LandingNavbar from "../navbar/LandingNavbar";
import Footer from "../../pages/Footer";

export default function GovtOfficialForm() {
  const [form, setForm] = useState({
    department: "",
    name: "",
    employeeId: "",
    contactNo: "",
    address: "",
    captcha: "",
  });

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("submit", form);
    // TODO: hook into your signup API...
  };

  return (
    <>
      <LandingNavbar />
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-full px-4 sm:px-6 lg:px-0 mx-auto max-w-sm sm:max-w-md md:max-w-lg lg:max-w-lg bg-blue-100 p-4 rounded-xl relative">
          {/* Icon in circle */}
          <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-gray-50 border-spacing-2 rounded-full p-2">
            <img src={GovtOfficial} alt="Building Icon" className="h-16 w-16" />
          </div>

          <h2 className="text-xl font-semibold text-gray-900 text-center mt-6 mb-4">
            Please Enter Your Details
          </h2>

          <form
            onSubmit={handleSubmit}
            className="space-y-2 px-6 py-4 flex flex-col items-center"
          >
            <select
              name="department"
              value={form.department}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
              required
            >
              <option value="">Department</option>
              <option value="finance">Finance</option>
              <option value="hr">Human Resources</option>
              <option value="it">IT</option>
            </select>

            <input
              type="text"
              name="name"
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 text-base"
              required
            />

            <input
              type="text"
              name="employeeId"
              placeholder="Employee ID"
              value={form.employeeId}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 text-base"
              required
            />

            <input
              type="tel"
              name="contactNo"
              placeholder="Department Contact no"
              value={form.contactNo}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg  focus:outline-none focus:ring-2 focus:ring-blue-200 text-base"
              required
            />

            <input
              type="text"
              name="address"
              placeholder="Registered Address"
              value={form.address}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 text-base"
              required
            />

            {/* Captcha display */}
            <div className="w-full bg-gray-100 border border-gray-200 p-4 rounded-lg flex justify-center items-center">
              <span className="text-lg font-mono tracking-wide">98-9=?</span>
            </div>
            <input
              type="text"
              name="captcha"
              placeholder="Please Enter Captcha"
              value={form.captcha}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 text-base"
              required
            />

            <button
              type="submit"
              className="mx-auto w-1/2 bg-blue-500 text-white py-2 rounded-full text-lg hover:bg-blue-600 transition-colors"
            >
              Sign Up
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}
